import React, { Component } from "react";
import PropTypes from "prop-types";
import utils from "@utils";
import { JOB_ASSIGNMENT_ERROR_TYPES } from "@constants/index";
import { Modal } from "../../../../../components";

import "./JobFormModals.scss";

class ConflictsModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			show: false,
			message: "",
			events: [],
			onOverrideConflicts: null,
		};
	}

	openModal = ({ message, events, onOverrideConflicts }) =>
		this.setState({
			show: true,
			message,
			events,
			onOverrideConflicts,
		});

	onHide = () =>
		this.setState({
			show: false,
			message: "",
			events: [],
			onOverrideConflicts: null,
		});

	onOverride = () => {
		const { onOverrideConflicts } = this.state;
		onOverrideConflicts();
		this.onHide();
	};

	render() {
		const { lang } = global;
		const { show, message, events, onOverrideConflicts } = this.state;
		const { timeZoneId, user } = this.props;
		const jobConflict = events?.some(e =>
			e?.ErrorTypes?.some(
				t =>
					t !== JOB_ASSIGNMENT_ERROR_TYPES.MAX_HOURS_REACHED_BASED_ON_NEW_RULES.value &&
					t !== JOB_ASSIGNMENT_ERROR_TYPES.MAX_WEEKLY_WORK_HOUR_REACHED.value &&
					t !== JOB_ASSIGNMENT_ERROR_TYPES.CONFLICTS_WITH_USER_SCHEDULE_OVERRIDE.value,
			),
		);
		const differentOfficerJurisdiction = events?.some(
			e => e?.AssignedOfficer?.JurisdictionId !== user?.Organization?.JurisdictionId,
		);
		const canOverride =
			(user?.isSuperAdmin() || (user?.isLEA() && !!user?.IsStaffAdmin)) &&
			!!onOverrideConflicts &&
			!jobConflict &&
			!differentOfficerJurisdiction;
		return (
			<Modal
				show={show}
				onHide={this.onHide}
				id="job-form-conflicts-modal"
			>
				<Modal.Header closeButton>
					<Modal.Title>{lang.t("Assignment Conflict")}</Modal.Title>
				</Modal.Header>
				<Modal.Body className="conflicts-modal-body">
					<div className="conflicts-modal-message">{message}</div>
					<div className="row hidden-xs">
						<div className="col-sm-2">{lang.t("Job ID")}</div>
						<div className="col-sm-3">{lang.t("Job Date")}</div>
						<div className="col-sm-3">{lang.t("Assigned Officer")}</div>
						<div className="col-sm-4">{lang.t("Reason")}</div>
					</div>
					<hr className="divider" />
					<For
						each="item"
						of={events}
					>
						<div
							className="row"
							key={`update_job_conflict_${item.JobEventId}`}
						>
							<div className="col-sm-2">
								<span className="visible-xs-inline-block job-conflict-label">{`${lang.t("Job ID")}:`}</span>
								<span>{item.JobEventId}</span>
							</div>
							<div className="col-sm-3">
								<span className="visible-xs-inline-block job-conflict-label">{`${lang.t("Job Date")}:`}</span>
								{utils.formatDate(
									`${item.StartDateTime}Z`,
									"en-US",
									timeZoneId,
									"dt-short",
								)}
							</div>
							<div className="col-sm-3">
								<span className="visible-xs-inline-block job-conflict-label">{`${lang.t("Assigned Officer")}:`}</span>
								{item.AssignedOfficer
									? `${item.AssignedOfficer.FirstName} ${item.AssignedOfficer.LastName}`
									: ""}
							</div>
							<div className="col-sm-4">
								<span className="visible-xs-inline-block job-conflict-label">{`${lang.t("Reason")}:`}</span>
								<span>{item.Errors.join(" ")}</span>
							</div>
						</div>
						<hr className="divider" />
					</For>
					<If condition={canOverride}>
						<div className="conflicts-modal-message">
							{lang.t("Would you like to override this_")}
						</div>
					</If>
				</Modal.Body>
				<Modal.Footer>
					<If condition={canOverride}>
						<button
							type="button"
							className="btn btn-primary btn-medium"
							onClick={this.onOverride}
						>
							{lang.t("Yes, Proceed")}
						</button>
						<button
							type="button"
							className="btn btn-primary btn-medium"
							onClick={this.onHide}
						>
							{lang.t("No, Cancel")}
						</button>
					</If>
					<If condition={!canOverride}>
						<button
							type="button"
							className="btn btn-primary btn-medium"
							onClick={this.onHide}
						>
							{lang.t("Accept")}
						</button>
					</If>
				</Modal.Footer>
			</Modal>
		);
	}
}

ConflictsModal.propTypes = {
	user: PropTypes.object,
	timeZoneId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

ConflictsModal.defaultProps = {
	user: {
		isSuperAdmin: () => false,
		isLEA: () => false,
	},
};

export default ConflictsModal;
